import React, { Component } from 'react'
//import image from './image/download.png'

class ForgotPassword extends Component {

  render() {
    return (
      <div style={{margin: "200px auto"}}>
          {/* <img src={image} /> */}
      </div>
    )
  }
}

ForgotPassword.defaultProps = {
}

export default ForgotPassword